// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/index_yuan.png");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, "\n.indexPanel2[data-v-007e2381] {\n  width: 100%;\n  background-color: #fff;\n  position: relative;\n  overflow: hidden;\n}\n.indexPanel2[data-v-007e2381]:after {\n  content: \"\";\n  position: absolute;\n  z-index: 1;\n  background: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");\n  background-size: 100% 100%;\n  width: 1103px;\n  height: 2053px;\n  right: 0;\n  bottom: -300px;\n}\n", ""]);
// Exports
module.exports = exports;
